<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>

        <div class="row mb-5">
            <div class="col-md-3">
                <button class="btn btn-primary" @click="() => $router.push({name: 'server.clans'})">
                    <i class="fa fa-arrow-left"></i> Powrót
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-tag h2 text-primary align-middle mb-0 mr-3"></i> Nazwa gildii
                        </p>

                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h3><server-group v-if="!loading" :group="data.group" withName/></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-user-tag h2 text-primary align-middle mb-0 mr-3"></i> Typ strefy
                        </p>

                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h3 v-if="!loading">{{ data.info.zoneName }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-user-shield h2 text-primary align-middle mb-0 mr-3"></i> Właściciel
                        </p>

                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h6 v-if="!loading"><client :client="data.owner" withAvatar/></h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-sort-numeric-up-alt h2 text-primary align-middle mb-0 mr-3"></i> Numer gildii
                        </p>

                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h3 v-if="!loading">Nr: {{ data.info.number }} | ID: {{ data.info.id }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-eye"></i> Podgląd kanałów
                    </div>
                    <div class="card-body">
                        <ul class="teamspeak-channels">
                            <channel
                                v-for="channel in data.preview"
                                :key="channel.cid"
                                :channel="channel"
                                :clickable="false"
                                real
                            />
                        </ul>
                        <small><i>Stan na: {{ data.previewGenerated | moment("DD-MM-YYYY HH:mm") }}</i></small>
                    </div>
                </div>

                <div class="card" v-if="!loading && data.stats">
                    <div class="card-header">
                        <i class="fa fa-chart-line"></i> Wykres aktywności
                    </div>
                    <div class="card-body">
                        <apexchart
                            class="apex-charts"
                            height="350"
                            type="area"
                            dir="ltr"
                            :series="series"
                            :options="chartOptions"
                        ></apexchart>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-users"></i> Użytkownicy
                    </div>
                    <div class="card-body">
                        <data-table
                            v-if="!loading"
                            :fields="fields"
                            :items="validClients"
                        >
                            <template v-slot:nick="row">
                                <client :client="row.item" withAvatar/>
                            </template>
                            <template v-slot:status="row">
                                <span v-if="row.value == 'online'" class="badge badge-success">Online</span>
                                <span v-else-if="row.value == 'offline'" class="badge badge-danger">Offline</span>
                                <span v-else class="badge badge-danger">Away</span>
                            </template>
                        </data-table>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ClansService from "@/services/clans.service";

/**
 * Starter component
 */
export default {
    name: "ClanSingle",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Klan",
            items: [
                {
                    text: "Serwer",
                    href: "/"
                },
                {
                    text: "Klan",
                    active: true
                }
            ],
            loading: true,
            data: {},
            fields: [
                {key: "nick", label: "Użytkownik"},
                {key: "status", label: "Status"},
            ],
            series: [],
            chartOptions: {
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 3,
                },
                colors: ['#556ee6', '#34c38f'],
                xaxis: {
                    type: 'datetime',
                    categories: [],
                },
                grid: {
                    borderColor: '#f1f1f1',
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yy HH:mm'
                    },
                }
            }
        };
    },
    computed: {
        clanId() {
            return this.$route.params.id;
        },
        validClients() {
            return this.data?.clients ? this.data.clients.filter(c => c.nick) : [];
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;

            ClansService.getSingle(this.clanId).then(
                response => {
                    this.data = response.data;
                    this.setStats();
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        setStats() {
            if (!this.data.stats)
                return;

            const statOnline = {
                name: 'Online',
                data: []
            }

            const statAll = {
                name: 'Wszyscy',
                data: []
            }

            this.chartOptions.xaxis.categories = [];

            this.data.stats.forEach(stat => {
                const time = Object.keys(stat)[0];
                stat = stat[time];
                statOnline.data.push(stat.online);
                statAll.data.push(stat.all);
                const date = new Date(time*1000);
                this.chartOptions.xaxis.categories.push(date.toISOString());
            });

            this.series = [statOnline, statAll];
        }
    }
};
</script>